/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Col_StepInputs */

const en_cases_col_step = /** @type {(inputs: Cases_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step`)
};

const pt_br2_cases_col_step = /** @type {(inputs: Cases_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa`)
};

/**
* | output |
* | --- |
* | "Step" |
*
* @param {Cases_Col_StepInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_col_step = /** @type {((inputs?: Cases_Col_StepInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_StepInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_col_step(inputs)
	return pt_br2_cases_col_step(inputs)
});